<template>
    <component :is="layout">
        <RouterView />
    </component>
    <Toast />
</template>

<script lang="ts" setup>
    import { computed } from 'vue'
    import { useRoute } from 'vue-router'
    import { Toast } from 'primevue'

    import Default from '@/layouts/Default.vue'
    import Blank from '@/layouts/Blank.vue'
    import { initToast } from '@/libs/toast'

    initToast()

    const route = useRoute()

    const layouts = { Default, Blank }
    const layout = computed(() => layouts[(route.meta.layout as keyof typeof layouts) ?? 'Default'])
</script>
